import { useDispatch, useSelector } from "react-redux";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import ProjectInformationPage from "../../../Containers/ProjectInformationPage";
import AdditionalSponsors from "./AdditionalSponsors";
import OrgExperienceSummary from "./OrgExperienceSummary";
import ProjectAdminTeam from "./ProjectAdminTeam";
import ProjectTechTeam from "./ProjectTechTeam";
import $ from "jquery";

import "./style.css";
import { useEffect, useState } from "react";
import {
  GetTE_MAinTeamMembersPreviousExperiencePartnershipsData,
  ValidateTE_MAinTeamMembersPreviousExperiencePartnershipsD,
} from "../../../Redux/Reducers/ProjectInformationPage/ProjectManagementTeamMembers";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";
import PopupAHSF from "../../../Components/PopupAHSF";
const TeamMembersModule = () => {
  const AppGuid = useParams();
  const dispatch = useDispatch();
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);
  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
      TeamMembersPreviousExperiencePartnerships:
        state.TeamMembersPreviousExperiencePartnerships
          .TeamMembersPreviousExperiencePartnerships,
      loadingGetTE_MAinTeamMembersPreviousExperiencePartnershipsData:
        state.TeamMembersPreviousExperiencePartnerships
          .loadingGetTE_MAinTeamMembersPreviousExperiencePartnershipsData,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      TeamMembersPreviousValidationPage:
        state.TeamMembersPreviousExperiencePartnerships
          .TeamMembersPreviousValidationPage,
    };
  });
  useEffect(() => {
    dispatch(
      GetTE_MAinTeamMembersPreviousExperiencePartnershipsData(
        localStorage.getItem("aI_ApplicationInformationId") ||
          decryptToken(AppGuid.AppGuid)
      )
    );
  }, []);

  const validatePage = async () => {
    const validate = await dispatch(
      ValidateTE_MAinTeamMembersPreviousExperiencePartnershipsD(
        localStorage.getItem("aI_ApplicationInformationId")
      )
    );
    if (validate.payload.length == 0) {
      // If validation passes, navigate to the next page
      $(".AdvertisingAndMediaPlan").trigger("click");
    } else {
      setisPopupOpenStatus(true); // Show popup if validation fails
    }
  };

  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );

  return !state.loadingGetTE_MAinTeamMembersPreviousExperiencePartnershipsData ? (
    <>
      <ProjectInformationPage active={5} />
      <SharedDiv
        showTitle={true}
        titleName="أعضاء فريق العمل - الخبرات السابقة - بناء وحشد الشراكات"
        child={[
          <>
            {" "}
            <ProjectAdminTeam
              tE_MAinTeamMembersPreviousExperiencePartnershipsId={
                state.TeamMembersPreviousExperiencePartnerships
                  ?.tE_MAinTeamMembersPreviousExperiencePartnershipsId
              }
            />
            <ProjectTechTeam
              tE_MAinTeamMembersPreviousExperiencePartnershipsId={
                state.TeamMembersPreviousExperiencePartnerships
                  ?.tE_MAinTeamMembersPreviousExperiencePartnershipsId
              }
            />
            <OrgExperienceSummary
              tE_MAinTeamMembersPreviousExperiencePartnershipsId={
                state.TeamMembersPreviousExperiencePartnerships
                  ?.tE_MAinTeamMembersPreviousExperiencePartnershipsId
              }
            />
            <AdditionalSponsors
              tE_MAinTeamMembersPreviousExperiencePartnershipsId={
                state.TeamMembersPreviousExperiencePartnerships
                  ?.tE_MAinTeamMembersPreviousExperiencePartnershipsId
              }
            />
          </>,
        ]}
      />
      {!shouldDisableFields ? (
        <div className="containerButtonMAin">
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم حفظ المعلومات بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
            }}
            disabled={false}
            title={"حفظ"}
            text={"حفظ"}
            show={true}
          />
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              validatePage();
            }}
            disabled={false}
            title={"التالي"}
            text={"التالي"}
            show={true}
          />
        </div>
      ) : (
        ""
      )}
      <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus}
        isPopupOpenFunction={() => setisPopupOpenStatus(false)} // Close popup
        forValidate={true}
        maxWidth="50%"
        title="يرجى تعبئة الحقول المطلوبة"
        componentBody={state.TeamMembersPreviousValidationPage} // Validation messages
      />
    </>
  ) : (
    ""
  );
};

export default TeamMembersModule;
